module.exports = __webpack_public_path__ + "media/eship-ecosystems-2.jpg";